import React from "react"
import {
    Container,
    Content
} from "rsuite"
import {
    useMediaQuery,
    Button
} from "@mui/material"
import { Outlet, useNavigate } from "react-router-dom"
import "rsuite/dist/rsuite.min.css"
import { useLazyGetInstitutionClassesQuery } from "../Redux/actions/classSetup.action"
import { Loader } from "../components/index"
import { useTheme } from "@mui/material/styles"
import "../components/LayoutFooter.css"

export default function StockLayout() {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("md"))
    const navigate = useNavigate()
    const [getClassesAction, getClassState] = useLazyGetInstitutionClassesQuery()

    React.useEffect(() => {
        const fetchData = async () => {
            navigate("/stock/registered_students")
            const user = await localStorage.getItem("current_user")
            if (user) {
                const userInfo = JSON.parse(user)
                const { user_data } = userInfo
                const { meta_data } = user_data
                if (meta_data && meta_data.hasOwnProperty('user_platform')) {
                    const institution_ref = meta_data.user_platform
                    getClassesAction({ institution_ref })
                }
            } else {
                localStorage.clear()
                navigate("/auth")
            }
        }
        fetchData()
    }, [])


    return (
        <Container className="layout-root">
            <Content className="layout-content">
                <Outlet />
            </Content>
            <div className="layout-footer">
                <div className="layout-footer-actions">
                    <Button
                        variant="outlined"
                        size="small"
                        color="secondary"
                        onClick={() => {
                            navigate("registered_students")
                        }}
                    >
                        Registered Students
                    </Button>
                    <Button
                        variant="outlined"
                        size="small"
                        color="secondary"
                        onClick={() => {
                            navigate("class_students")
                        }}
                    >
                        Class Students
                    </Button>
                </div>
            </div>
            {
                (
                    getClassState.isLoading
                ) && (
                    <Loader show={true} />
                )
            }
        </Container>
    );
}

